import { CaseInfoBannerKey, CaseLandingViewProps } from "src/pages/case-landing/case-landing-view-model";
import { PortalState } from "src/api/types/enums";

export function useGeneralFallbackViewProps(state: PortalState): CaseLandingViewProps {
  switch (state) {
    case PortalState.Cancelled: {
      return {
        bannerKey: CaseInfoBannerKey.Cancelled,
      };
    }
    case PortalState.Unknown: {
      return {
        bannerKey: CaseInfoBannerKey.Unknown,
      };
    }
    default:
      return {
        bannerKey: CaseInfoBannerKey.Unknown,
      };
  }
}
